export default {
  dataIterator: {
    rowsPerPageText: 'Élements par page:',
    rowsPerPageAll: 'Tous',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'Aucun enregistrement correspondant trouvé',
    nextPage: 'Page suivante',
    prevPage: 'Page précédente'
  },
  dataTable: {
    rowsPerPageText: 'Lignes par page:'
  },
  noDataText: 'Aucune donnée disponible'
}
